export interface FundRequest {
  id: string;
  requestId: string;
  requestorFirstName: string;
  requestorLastName: string;
  clientName: string;
  customerProject: string;
  expenseType: 'Labour' | 'Material' | 'Fuel' | 'Transport' | 'Accommodation';
  amountRequested: number;
  status: 'Submitted' | 'Approved' | 'Released';
  bankReference: string;
  releaseDate: string | null;
  attachmentCount: number;
  createdAt: string;
}

export interface LeaveRequest {
  id: string;
  employeeId: string;
  department: string;
  typeOfLeave: string;
  startDate: string;
  endDate: string;
  reason: string;
  createdAt: string;
  approvedAt?: string | null;
}

export const fundRequests: FundRequest[] = [
  {
    id: 'fr-001',
    requestId: 'FR-20260901-841023',
    requestorFirstName: 'Amara',
    requestorLastName: 'Nkosi',
    clientName: 'TanzaPort Authority',
    customerProject: 'Port Expansion Phase 2',
    expenseType: 'Labour',
    amountRequested: 4500000,
    status: 'Submitted',
    bankReference: '',
    releaseDate: null,
    attachmentCount: 2,
    createdAt: '01-Sep-2026',
  },
  {
    id: 'fr-002',
    requestId: 'FR-20260901-763412',
    requestorFirstName: 'Jabari',
    requestorLastName: 'Okonkwo',
    clientName: 'Kilimanjaro Breweries',
    customerProject: 'Bottling Line Upgrade',
    expenseType: 'Material',
    amountRequested: 12750000,
    status: 'Approved',
    bankReference: 'CRDB-2026-44821',
    releaseDate: null,
    attachmentCount: 3,
    createdAt: '01-Sep-2026',
  },
  {
    id: 'fr-003',
    requestId: 'FR-20260902-512908',
    requestorFirstName: 'Zawadi',
    requestorLastName: 'Mwangi',
    clientName: 'TANESCO Grid Services',
    customerProject: 'Rural Electrification Zone 4',
    expenseType: 'Transport',
    amountRequested: 2100000,
    status: 'Released',
    bankReference: 'NMB-2026-39012',
    releaseDate: '03-Sep-2026',
    attachmentCount: 1,
    createdAt: '02-Sep-2026',
  },
  {
    id: 'fr-004',
    requestId: 'FR-20260902-334871',
    requestorFirstName: 'Nia',
    requestorLastName: 'Kamau',
    clientName: 'Dar es Salaam Roads Agency',
    customerProject: 'Bagamoyo Road Resurfacing',
    expenseType: 'Fuel',
    amountRequested: 870000,
    status: 'Submitted',
    bankReference: '',
    releaseDate: null,
    attachmentCount: 0,
    createdAt: '02-Sep-2026',
  },
  {
    id: 'fr-005',
    requestId: 'FR-20260903-219034',
    requestorFirstName: 'Kofi',
    requestorLastName: 'Asante',
    clientName: 'Serengeti National Park',
    customerProject: 'Visitor Centre Renovation',
    expenseType: 'Accommodation',
    amountRequested: 3300000,
    status: 'Approved',
    bankReference: 'CRDB-2026-44902',
    releaseDate: null,
    attachmentCount: 4,
    createdAt: '03-Sep-2026',
  },
  {
    id: 'fr-006',
    requestId: 'FR-20260903-891234',
    requestorFirstName: 'Imani',
    requestorLastName: 'Dlamini',
    clientName: 'Moshi Municipal Council',
    customerProject: 'Water Treatment Plant',
    expenseType: 'Material',
    amountRequested: 8400000,
    status: 'Released',
    bankReference: 'BOT-2026-11234',
    releaseDate: '04-Sep-2026',
    attachmentCount: 2,
    createdAt: '03-Sep-2026',
  },
  {
    id: 'fr-007',
    requestId: 'FR-20260904-667123',
    requestorFirstName: 'Tafari',
    requestorLastName: 'Bekele',
    clientName: 'Arusha Tech Hub',
    customerProject: 'Data Centre Fit-Out',
    expenseType: 'Labour',
    amountRequested: 6750000,
    status: 'Submitted',
    bankReference: '',
    releaseDate: null,
    attachmentCount: 1,
    createdAt: '04-Sep-2026',
  },
  {
    id: 'fr-008',
    requestId: 'FR-20260904-443009',
    requestorFirstName: 'Zuri',
    requestorLastName: 'Osei',
    clientName: 'Zanzibar Tourism Board',
    customerProject: 'Stone Town Heritage Restoration',
    expenseType: 'Material',
    amountRequested: 5200000,
    status: 'Submitted',
    bankReference: '',
    releaseDate: null,
    attachmentCount: 3,
    createdAt: '04-Sep-2026',
  },
  {
    id: 'fr-009',
    requestId: 'FR-20260905-112345',
    requestorFirstName: 'Amara',
    requestorLastName: 'Nkosi',
    clientName: 'TanzaPort Authority',
    customerProject: 'Crane Maintenance Q3',
    expenseType: 'Fuel',
    amountRequested: 1450000,
    status: 'Approved',
    bankReference: 'NMB-2026-40011',
    releaseDate: null,
    attachmentCount: 2,
    createdAt: '05-Sep-2026',
  },
  {
    id: 'fr-010',
    requestId: 'FR-20260905-778901',
    requestorFirstName: 'Seun',
    requestorLastName: 'Adeyemi',
    clientName: 'Dodoma Capital Projects',
    customerProject: 'Parliament Annex Construction',
    expenseType: 'Transport',
    amountRequested: 990000,
    status: 'Submitted',
    bankReference: '',
    releaseDate: null,
    attachmentCount: 0,
    createdAt: '05-Sep-2026',
  },
  {
    id: 'fr-011',
    requestId: 'FR-20260905-334512',
    requestorFirstName: 'Jabari',
    requestorLastName: 'Okonkwo',
    clientName: 'Kilimanjaro Breweries',
    customerProject: 'Cold Storage Expansion',
    expenseType: 'Accommodation',
    amountRequested: 1800000,
    status: 'Released',
    bankReference: 'CRDB-2026-45001',
    releaseDate: '05-Sep-2026',
    attachmentCount: 1,
    createdAt: '05-Sep-2026',
  },
];

export const leaveRequests: LeaveRequest[] = [
  {
    id: 'lr-001',
    employeeId: 'EMP-0042',
    department: 'Operations',
    typeOfLeave: 'Sick Leave',
    startDate: '08-Sep-2026',
    endDate: '09-Sep-2026',
    reason: 'Fever and flu symptoms',
    createdAt: '05-Sep-2026',
  },
  {
    id: 'lr-002',
    employeeId: 'EMP-0078',
    department: 'Finance',
    typeOfLeave: 'Casual Leave',
    startDate: '10-Sep-2026',
    endDate: '10-Sep-2026',
    reason: 'Personal appointment',
    createdAt: '04-Sep-2026',
  },
  {
    id: 'lr-003',
    employeeId: 'EMP-0115',
    department: 'Sales',
    typeOfLeave: 'Public Holiday',
    startDate: '12-Sep-2026',
    endDate: '12-Sep-2026',
    reason: 'National holiday observance',
    createdAt: '03-Sep-2026',
  },
  {
    id: 'lr-004',
    employeeId: 'EMP-0033',
    department: 'Marketing',
    typeOfLeave: 'Sick Leave',
    startDate: '06-Sep-2026',
    endDate: '07-Sep-2026',
    reason: 'Medical procedure follow-up',
    createdAt: '05-Sep-2026',
  },
  {
    id: 'lr-005',
    employeeId: 'EMP-0091',
    department: 'Packaging',
    typeOfLeave: 'Casual Leave',
    startDate: '09-Sep-2026',
    endDate: '11-Sep-2026',
    reason: 'Family event',
    createdAt: '04-Sep-2026',
  },
  {
    id: 'lr-006',
    employeeId: 'EMP-0056',
    department: 'Operations',
    typeOfLeave: 'Casual Leave',
    startDate: '15-Sep-2026',
    endDate: '15-Sep-2026',
    reason: '',
    createdAt: '05-Sep-2026',
  },
  {
    id: 'lr-007',
    employeeId: 'EMP-0022',
    department: 'Finance',
    typeOfLeave: 'Sick Leave',
    startDate: '08-Sep-2026',
    endDate: '10-Sep-2026',
    reason: 'Scheduled surgery recovery',
    createdAt: '02-Sep-2026',
  },
];

export function formatTZS(amount: number): string {
  return 'TZS ' + amount.toLocaleString('en-TZ');
}

export const leaveTypeChartData = [
  { type: 'Sick Leave', count: 3, fill: 'var(--danger)' },
  { type: 'Casual Leave', count: 3, fill: 'var(--primary)' },
  { type: 'Public Holiday', count: 1, fill: 'var(--accent)' },
];

export const expenseTypeChartData = [
  { type: 'Labour', count: 2, amount: 11250000 },
  { type: 'Material', count: 3, amount: 26350000 },
  { type: 'Fuel', count: 2, amount: 2320000 },
  { type: 'Transport', count: 2, amount: 3090000 },
  { type: 'Accommodation', count: 2, amount: 5100000 },
];